import { ID } from '@datorama/akita';
import {RelationConfig} from '../../models/relation-config.model';

export interface Vehicle {
  id: ID;
  person_id: number;
  description: string;
  make: string;
  model: string;
  registration: string;
  km: string;
  insurance: string;
  current_value: string;
  purchase_price: string;
  vehicle_tax: string;
  specialties: string;
  type: RelationConfig;
  type_configuration_id?: number;
}

export function createVehicle(params: Partial<Vehicle>) {
  return {
    type_configuration_id: 424
  } as Vehicle;
}
